import styled from '@emotion/styled';
import { SidebarCategory } from '@hotjar/insights-common/components/SidebarCategory';
import { Loader } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import { useTrackingState, TrackingState } from './hooks/useTrackingState';
import { SuccessState } from './components/SuccessState';
import { NotInstalledState } from './components/NotInstalledState';
import { DisabledState } from './components/DisabledState';
import { WarningState } from './components/WarningState';

const Wrapper = styled.div`
  a,
  a:link {
    text-decoration: underline;
  }
`;

interface TrackingStatusProps {
  trackingUIPosition?: string;
}

export function TrackingStatus({ trackingUIPosition }: TrackingStatusProps): JSX.Element {
  const { t } = useTranslation();
  const state = useTrackingState();

  return (
    <SidebarCategory
      hideDivider
      categoryId="tracking-status"
      title={t('activation:dashboard.status-card.hotjar-status')}
    >
      <Wrapper>
        {state === TrackingState.LOADING ? <Loader /> : null}
        {state === TrackingState.NOT_INSTALLED ? (
          <NotInstalledState trackingUIPosition={trackingUIPosition} />
        ) : null}
        {state === TrackingState.DISABLED ? (
          <DisabledState trackingUIPosition={trackingUIPosition} />
        ) : null}
        {state === TrackingState.WARNING ? (
          <WarningState trackingUIPosition={trackingUIPosition} />
        ) : null}
        {state === TrackingState.SUCCESS ? (
          <SuccessState trackingUIPosition={trackingUIPosition} />
        ) : null}
      </Wrapper>
    </SidebarCategory>
  );
}
